import React from "react";

const Map = () => {
  return (
    <section id="map" style={{ padding: "2rem", backgroundColor: "#f5f5f5" }}>
      <h2 style={{ textAlign: "center", marginBottom: "2rem" }}>Location</h2>
      <div style={{ textAlign: "center" }}>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3024.2219!2d-74.2794!3d40.7319!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c3b0b2b2b2b2b2b%3A0x1234567890abcdef!2s10%20Roosevelt%20Rd%2C%20Maplewood%2C%20NJ%2007040!5e0!3m2!1sen!2sus!4v1234567890!5m2!1sen!2sus"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Property Location"
        ></iframe>
      </div>
    </section>
  );
};

export default Map;